import React from 'react';
import PropTypes from 'prop-types';
import Card from 'src/components/Cards/Card';
import TextButton from 'src/components/TextButton';
import AvatarImage from 'shared/components/avatar-image';

const propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  mobile: PropTypes.string,
  image: PropTypes.string,
  handleRemoveClick: PropTypes.func,
};

const StudentInformationCard = ({firstName, lastName, email, mobile, image, handleRemoveClick}) => (
  <Card className="student-information-card">
    <div className="row student-information-card-container">
      <div className="col-sm-1 col-xs-2">
        <AvatarImage userInfo={{firstName, lastName, image}} />
      </div>
      <div className="col-sm-8 col-xs-8">
        <div className="student-information-card-name">
          {firstName} {lastName}
        </div>
        <div className="student-information-card-contact">{email ? email : mobile}</div>
      </div>
      <div className="col-sm-3 col-xs-2 student-information-card-remove-button">
        <TextButton onClick={handleRemoveClick} className="alternate">
          Remove
        </TextButton>
      </div>
    </div>
  </Card>
);

StudentInformationCard.propTypes = propTypes;

export default StudentInformationCard;
